module.exports = __webpack_public_path__ + "assets/klevu.b9bdd6ff.svg";